export default {
  namespaced: true,
  state: () => ({}),
  mutations: {
    setEmpresasPropias(state, payload) {
      state.empresasPropias = payload;
    },
  },
  actions: {
    async getEmpresasPropias(context, payload) {
      context.commit("setEmpresasPropias", payload);
    },
  },
};
